import { handleResetSearch } from 'helpers/searchReset';
import { StorefrontContext } from 'providers/storefront';
import React, { useContext } from 'react';
import styles from './styles';

const PostPageSidebar = ({
  activeArticleIndex,
  handleChangeArticle,
  scrollToHeader,
  preparedTitles,
}) => {
  const { setFilteredResults, setSearchInput } = useContext(StorefrontContext);

  return (
    <>
      <div className="discussions">
        <div className="dicussions-content-wrapper">
          <h3 className="discussions-title">Content</h3>
          <div className="discussions-wrapper">
            {preparedTitles?.map((title) => (
              <div key={title.id}>
                <span
                  onClick={() => {
                    handleChangeArticle(title.id);
                    handleResetSearch(setFilteredResults, setSearchInput);
                    scrollToHeader(title.id);
                  }}
                  className={`discussion ${
                    activeArticleIndex === title.id ? 'active' : ''
                  }`}
                >
                  {title.text}
                </span>

                {title.subTitles.length > 0 && (
                  <div className="sub-titles-wrapper">
                    {title.subTitles?.map((subTitle) => (
                      <span
                        key={subTitle.id}
                        onClick={() => {
                          handleChangeArticle(subTitle.id);
                          handleResetSearch(setFilteredResults, setSearchInput);
                          scrollToHeader(subTitle.text.split(' ').join('-').toLowerCase());
                        }}
                        className={`discussion sub-discussion ${
                          activeArticleIndex === subTitle.id ? 'active' : ''
                        }`}
                      >
                        {subTitle.text}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default PostPageSidebar;
